import {Button} from 'platform/components';
import {Show} from 'platform/foundation';

import {t} from '../utils/catalogueUi';

/** An edited item read again after a new pricelist version moved its version; Save waits for it. */
export type ItemReadAgain = {isFetching: boolean; isError: boolean; retry: () => void};

/** After a failed read Save stays off; this reads the item again. */
export function RetryReadButton(props: {read?: ItemReadAgain}) {
  return (
    <Show when={props.read?.isError ? props.read : null}>
      {(read) => (
        <Button
          variant="secondary"
          title={t('general.actions.retry', 'Retry')}
          onClick={read.retry}
        />
      )}
    </Show>
  );
}
